if (!customElements.get("delivery-date")) {
  class DeliveryDate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      // Run once on load for THIS element
      this.initDeliveryDates();
    }

    addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    monthsByLocale() {
      if (Shopify.locale !== "fr") {
        return [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
      }
      return [
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Jun",
        "Jui",
        "Aout",
        "Sep",
        "Oct",
        "Nov",
        "Déc",
      ];
    }

    formatDate(d) {
      const months = this.monthsByLocale();
      return d.getDate() + " " + months[d.getMonth()];
    }

    parseDateAny(input) {
      if (!input) return null;

      const mdy = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const match = String(input).match(mdy);
      if (match) {
        const mm = parseInt(match[1], 10) - 1;
        const dd = parseInt(match[2], 10);
        const yyyy = parseInt(match[3], 10);
        const d = new Date(yyyy, mm, dd);
        return isNaN(d.getTime()) ? null : d;
      }

      const d = new Date(input);
      return isNaN(d.getTime()) ? null : d;
    }

    getExpectedDeliveryDate(incomingPoRaw) {
      if (!incomingPoRaw) return null;

      let obj = incomingPoRaw;
      if (typeof incomingPoRaw === "string") {
        const normalized = incomingPoRaw.replace(/&quot;/g, '"');

        try {
          obj = JSON.parse(normalized);
        } catch (e) {
          return null;
        }
      }

      const list = Array.isArray(obj) ? obj : [obj];
      let best = null;
      for (const item of list) {
        const val = item?.ExpectedDeliveryDate || item?.expecteddeliverydate;
        const d = this.parseDateAny(val);

        if (d && (!best || d < best)) best = d;
      }
      return best;
    }

    renderDeliveryRange(
      variantId,
      productId,
      baseDate,
      fromOffsetDays,
      toOffsetDays,
    ) {
      const wrap =
        this.querySelector(
          '.meta_deliver[data-variant-id="' + variantId + '"]',
        ) ||
        this.querySelector(
          '.meta_deliver[data-product-id="' + productId + '"]',
        ) ||
        this.querySelector(".meta_deliver");

      if (!wrap) return;

      const cEl = wrap.querySelector(".prod_current_date");
      const nEl = wrap.querySelector(".prod_next_date");
      if (!cEl || !nEl) return;

      const fromDate = this.addDays(baseDate, fromOffsetDays);
      const toDate = this.addDays(baseDate, toOffsetDays);

      cEl.textContent = this.formatDate(fromDate);
      nEl.textContent = this.formatDate(toDate);

      const lineInput = document.querySelector(
        '.line-item-property__field[data-variant-id="' +
          variantId +
          '"] #delivery-date',
      );
      if (lineInput) {
        lineInput.value =
          "Approximate Delivery Date :" + this.formatDate(toDate);
      }
    }

    computeAndRender(el) {
      const productId = el.getAttribute("data-product-id");
      const variantId = el.getAttribute("data-variant-id");

      const inventoryQty = parseInt(
        el.getAttribute("data-inventory-qty") || "0",
        10,
      );

      let incomingRaw = el.getAttribute("data-incoming-po") || "";
      incomingRaw = incomingRaw.replace(/&quot;/g, '"');

      const expectedDate = this.getExpectedDeliveryDate(incomingRaw);

      // ✅ CASE 1: In stock
      if (inventoryQty > 0) {
        this.renderDeliveryRange(variantId, productId, new Date(), 5, 10);
        return;
      }

      // ✅ CASE 2: Not in stock + ExpectedDeliveryDate
      if (expectedDate) {
        this.renderDeliveryRange(variantId, productId, expectedDate, 5, 10);
        return;
      }

      // ✅ CASE 3: No data fallback
      this.renderDeliveryRange(variantId, productId, new Date(), 125, 130);
    }

    initDeliveryDates() {
      const els = this.querySelectorAll(".meta_deliver");
      els.forEach((node) => this.computeAndRender(node));
    }
  }

  customElements.define("delivery-date", DeliveryDate);
}
